var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv_flexalign_center act_layout"},[_c('div',{staticClass:"act_button",on:{"click":_vm.remove}},[_vm._v("复制选中")])])
}
var staticRenderFns = []

export { render, staticRenderFns }